import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { Permissions } from '../core/enums/permissions.enum';

export const PagesRoutes: Routes = [
  {
    path: 'detail-pay',
    loadChildren: () => import('./detail-pay/detail-pay.module').then((m) => m.DetailPayModule)
  },
  {
    path: 'cashin-cashout',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.COBRAR
    },
    loadChildren: () => import('./collect-options/collect-options.module').then((m) => m.CollectOptionsModule)
  },
  {
    path: 'Preguntas-Frecuentes',
    loadChildren: () => import('./frequent-questions/frequent-questions.module').then((m) => m.FrequentQuestionsModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule)
  },
  {
    path: 'Terminos-y-Condiciones',
    loadChildren: () =>
      import('./terms-and-conditions/terms-and-conditions.module').then((m) => m.TermsAndConditionsModule)
  },
  {
    path: 'account-yacare',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.INICIO
    },
    loadChildren: () => import('./account-yacare/account-yacare.module').then((m) => m.AccountYacareModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule)
  },
  {
    path: 'balance-schedule',
    loadChildren: () => import('./balance-schedule/balance-schedule.module').then((m) => m.BalanceScheduleModule)
  },
  {
    path: 'user-qr',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.COBRAR
    },
    loadChildren: () => import('./user-qr/user-qr.module').then((m) => m.UserQrModule)
  },
  {
    path: 'inbox',
    canActivate: [AuthGuard],
    loadChildren: () => import('./inbox/inbox.module').then((m) => m.InboxModule)
  },
  {
    path: 'cashout',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.TRANSFERENCIA
    },
    loadChildren: () => import('./cash-out/cash-out.module').then((m) => m.CashOutModule)
  },
  {
    path: 'movements',
    canActivate: [AuthGuard],
    loadChildren: () => import('./table-movements/table-movements.module').then((m) => m.TableMovementsModule),
    data: {
      page: { type: 'string', default: '1' },
      paymentMethod: { type: 'array', default: [] },
      paymentState: { type: 'array', default: [] },
      dateFrom: { type: 'number', default: 1 },
      dateTo: { type: 'number', default: 0 },
      accreditationDateFrom: { type: 'number', default: 1 },
      accreditationDateTo: { type: 'number', default: 0 },
      permission: Permissions.MOVIMIENTO
    }
  },
  {
    path: 'my-commerce',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.MI_COMERCIO
    },
    loadChildren: () => import('./my-commerce/my-commerce.module').then((m) => m.MyCommerceModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./help-view/help-view.module').then((m) => m.HelpViewModule)
  },
  {
    path: 'deposit-money',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.COBRAR
    },
    loadChildren: () => import('./deposit-money/deposit-money.module').then((m) => m.DepositMoneyModule)
  },
  {
    path: 'my-queries',
    canActivate: [AuthGuard],
    loadChildren: () => import('./my-queries/my-queries.module').then((m) => m.MyQueriesModule)
  },
  {
    path: 'pay-order',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.COBRAR
    },
    loadChildren: () => import('./pay-order/pay-order.module').then((m) => m.PayOrderModule)
  },
  {
    path: 'pix-pay',
    canActivate: [AuthGuard],
    data: {
      permission: Permissions.COBRAR
    },
    loadChildren: () => import('./pix-pay/pix-pay.module').then((m) => m.PixPayModule)
  }
];

export function breadcrumbCRUD(action: string, entity: string): string {
  return `components.breadcrumb.${action == 'create' ? 'create' : 'edit'}.${entity}`;
}
